import { Grid } from "@mui/material";
import { useFormik } from "formik";
import React, {useEffect, useState} from "react";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDBox from "../../Components/MDBox";
import MDButton from "../../Components/MDButton";
import MDDivider from "../../Components/MDDivider";
import MDInput from "../../Components/MDInput";
import MDTypography from "../../Components/MDTypography";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import * as Yup from "yup";
import { ErrorToaast, SuccessToaast } from "../../utils/toast/Toast";
import { v4 as uuid } from "uuid";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import {ServiceModel} from "../../Api/Models/ServiceModel";
import DeleteDialog from "./components/DeleteDialog";
const validationSchema = Yup.object().shape({
    name: Yup.string().typeError("نام وسیله الزامی است").required("نام سرویس الزامی است "),

});
export default function AvarezService() {
    const serviceModel = new ServiceModel();
    const [searched, setSearched] = useState<any[]>([]);
    const [reloade, setReloade] = useState(false);
    const [editable, setEditable] = useState<number>(0);
    const [deleteOpen, setDeleteOpen] = useState<{ open: boolean; id: number }>({ open: false, id: 0 });
      const formik = useFormik({
        initialValues: {
            name: "",
            description: "",
            // produceYear:'',
            isDelete: false,
        },
        validationSchema,
        validateOnChange: false,
        validateOnBlur: false,
        validateOnMount: false,
        onSubmit: (items) => {
            if (editable !== 0) {
                // if (!items.isDelete) {
                //     ErrorToaast("وضعیت غیر فعال میباشد");
                //     return;
                // }
                serviceModel
                    .EditData({ ...formik.values, id: editable })
                    .then((r) => {
                        load()
                        SuccessToaast("با موفقیت ویرایش شد")
                    })
                    .catch((e) => {
                        console.log(e)
                        ErrorToaast("خطا در برقراری ارتباط");
                    });
            } else {
                serviceModel
                    .SubmitData(items)
                    .then((r) => {
                      load()
                        SuccessToaast("با موفقیت اضافه شد")
                    })
                    .catch((e) => ErrorToaast("خطا در برقراری ارتباط"));
            }
            formik.resetForm();
            setEditable(0);
        },
    });
    const handleSearch = () => {
        serviceModel
            .GetSearch(
                formik.values.name,
                formik.values.description,
            ).then((r) => {
            setSearched(r.data.data);
            formik.resetForm();
            setEditable(0);
        })
            .catch((e) => ErrorToaast("مشکل در برقراری ارتباط"));
    };
    const load=async ()=>{
        try {
          const data=await serviceModel.GetAll()
            setSearched(data.data.data);
        }catch(e) {
            console.log(e)
        }
    }
    useEffect(() => {
       load()
    }, []);

    const handleRowClick = (data: any) => {
        formik.setFieldValue("name", data.name);
        formik.setFieldValue("description", data.description);
        formik.setFieldValue("isDelete", data.isDelete);
    };
    const handleChangeStatus = () => {
        // if (editable === 0) return;
        // //handle
        // ServiceModel
        //     .ChangeStatus(editable)
        //     .then((result: any) => {
        //         SuccessToaast("وضعیت با موفقیت تغیر یافت");
        //         formik.setFieldValue("isDelete", !formik.values.isDelete);
        //     })
        //     .catch((err: any) => {
        //         ErrorToaast("با مشکل مواجه شد");
        //     });
    };
    return (
        <DashboardLayout>
            <DashboardNavbar name={" مشخصات نوع سرویس   "} />
            <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
                <MDBox bgColor="white" borderRadius="5px" p="10px 5px">
                    <MDTypography fontWeight="bold" fontSize="14px">
                        مشخصات نوع سرویس
                    </MDTypography>
                    <MDDivider />
                    <MDBox py={2}>
                        <Grid container spacing={2} textAlign={"center"}>

                            <Grid container item xs={4} alignItems="center">
                                <Grid item container  xs={12}>
                                    <MDTypography fontSize="15px">نام سرویس </MDTypography>
                                </Grid>
                                <Grid item flex={1}>
                                    <MDInput
                                        fullWidth
                                        size="small"
                                        onChange={formik.handleChange}
                                        name="name"
                                        value={formik.values.name}
                                        error={formik.touched.name && Boolean(formik.errors.name)}
                                        helperText={formik.touched.name && formik.errors.name || ' '}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container item xs={4} alignItems="center">
                                <Grid container item xs={12}>
                                    <MDTypography fontSize="15px">توضیحات</MDTypography>
                                </Grid>
                                <Grid item flex={1}>
                                    <MDInput
                                        fullWidth
                                        size="small"
                                        onChange={formik.handleChange}
                                        name="description"
                                        value={formik.values.description}
                                        helperText={ ' '}
                                    />
                                </Grid>
                            </Grid>



                        </Grid>
                    </MDBox>
                </MDBox>
                <MDBox bgColor="white" borderRadius="5px" p="10px 5px">
                    <MDBox>
                        <Grid container columnGap={4} columns={10} justifyContent="center">
                            <Grid item xs={2}>
                                <MDButton
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        formik.resetForm();
                                        setEditable(0);
                                    }}
                                    color="success"
                                >
                                    جدید
                                </MDButton>
                            </Grid>
                            <Grid item xs={2}>
                                <MDButton fullWidth variant="contained" color="warning" type="submit">
                                    ثبت
                                </MDButton>
                            </Grid>

                            <Grid item xs={2}>
                                <MDButton fullWidth variant="contained" color="primary" onClick={handleSearch}>
                                    جستجو
                                </MDButton>
                            </Grid>
                        </Grid>
                    </MDBox>
                    <MDBox minHeight="40vh" maxHeight="40vh" sx={{ overflow: "auto" }} bgColor="#adaabb" mt={4} border="2px #5b5b5b solid">
                        <MDBox bgColor="#eeeeee" px={1}>
                            <Grid container textAlign="center">
                                <Grid item xs={4}>
                                    <MDTypography fontSize={"14px"}>نام   </MDTypography>
                                </Grid>
                                <Grid item xs={4}>
                                    <MDTypography fontSize={"14px"}>توضیحات</MDTypography>
                                </Grid>
                                <Grid item xs={4}>
                                    <MDTypography fontSize={"14px"}>حذف</MDTypography>
                                </Grid>
                            </Grid>
                        </MDBox>
                        {searched.length > 0 &&
                            searched.map((data: any, index: number) => {
                                return (
                                    <MDBox
                                        bgColor={index % 2 === 0 ? "#fbfbfb" : "white"}
                                        px={1}
                                        key={uuid()}
                                        onClick={() => {
                                            handleRowClick(data);
                                            setEditable(data.id);
                                        }}
                                        sx={{ ":hover": { background: "#9185c8" }, cursor: "pointer" }}
                                    >
                                        <Grid container textAlign="center">
                                            <Grid item xs={4}>
                                                <MDTypography fontSize={"14px"}>{data.name ?? ""}</MDTypography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <MDTypography fontSize={"14px"}>{data.description ?? ""}</MDTypography>
                                            </Grid>

                                         

                                            <Grid item xs={4}>
                                                <MDBox
                                                    onClick={(e: any) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setDeleteOpen({ open: true, id: data.id });
                                                    }}
                                                >
                                                    <DeleteIcon color="error" />
                                                </MDBox>
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                );
                            })}
                    </MDBox>

                </MDBox>
                <DeleteDialog
                    open={deleteOpen.open}
                    id={deleteOpen.id}
                    setClose={() => setDeleteOpen({ id: 0, open: false })}
                    onDone={() => {
                        setDeleteOpen({ open: false, id: 0 });
                        load();
                    }}
                />
            </MDBox>
        </DashboardLayout>
    );
}
